export interface InquiryTypes {
  value: string
  name: string
}

export const typeOfInquiries = ['Sales', 'After Sales', 'Careers', 'Others']
